(function (app) {
  $(document).ready(function () {

    app.UserTags = {};

    app.ImageTagList = function () {

      var _this = this;

      var nameSpace = 'ImageTagList',
        getUrl = '/api/image/tag',
        context = '.image-tags__list-container',
        dataTable = '.table__image-tags-list',
        templates = {
          'imageTagRow': app.templates["Image__tags____row"]
        },

        defaultPageParams = {
          'pageSize': 20,
          'pageNo': 1,
          'q': '',
          'orderBy': 'dateCreated',
          'orderByOrder': "DESC",
          'group': '',
          'queryVal': 'no-trigger',
          'query': ''
        };


      _this.initModal = function () {
        _this.modalEdit = $(app.templates["Image__tags____modal-tag-edit"]);
        $('body').append(_this.modalEdit);


        _this.id = _this.modalEdit.assignId();
        _this.$modalEdit = $('#' + _this.id);

        var $form = $('form[name=image-tag-name]', _this.$modalEdit);
        var form = $form[0];
        form.addEventListener('submit', function (event) {
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          } else {
            event.preventDefault();
            var $button = $(form).find('button[type=submit]');
            var method = $(form).attr('method');
            if (method == 'PUT') {
              $.when(_this.imageTagActions().update($form)).done(function () {
                $button.button('reset');
                _this.$modalEdit.modal('hide');

                $.when(_this.get()).done(function (response) {
                  _this.pager().init(response);
                  $button.button('reset');
                });

              }).fail(function () {
                $button.button('reset');
              });
            }
            if (method == 'POST') {
              $.when(_this.imageTagActions().add($form)).done(function () {
                $button.button('reset');
                _this.$modalEdit.modal('hide');

                $.when(_this.get()).done(function (response) {
                  _this.pager().init(response);
                  $button.button('reset');
                });

              }).fail(function () {
                $button.button('reset');
              });
            }

          }
          form.classList.add('was-validated');

        }, false);

      };

      _this.destroyModal = function () {
        $('[data-modal-image-tag-edit]').remove();
      };


      // To update Table view
      _this.updateList = function (response) {
        // Clean up all existing data in dom
        var $imageTagsBody = $('.table__image-tags-body', $(context));
        $imageTagsBody.html('');
        $(dataTable).removeClass('loading-state');

        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            var imageTagRow = _.template(templates.imageTagRow);
            var $imageTagRow = $(
              imageTagRow(
                $.extend(row, {
                  'dateCreated': moment(row.dateCreated).format('MM/DD/YYYY @ h:mm a'),
                })
              )
            );
            $imageTagRow.appendTo($imageTagsBody);
          });
        } else {
          $('.page__no--records', $(dataTable)).show();
        }
      };

      _this.imageTagActions = function () {
        return {
          getUserTags: function (fetchFromServer) {
            fetchFromServer = typeof fetchFromServer == 'undefined';
            var query = $.Deferred();
            if (fetchFromServer) {
              var appTransport = app.transport();
              appTransport
                .setEvent('onSuccess', function (response) {
                  app.UserTags = response;
                  return query.resolve(response);
                })
                .setEvent('onError', function (error) {
                  app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                })
                .setEvent('onComplete', function () {

                })
              ;
              appTransport.get('/api/user/tag');
            } else {
              return query.resolve(app.UserTags);
            }

            return query.promise();
          },
          add: function ($form) {
            var requestData = {'tag': $form.find(':input[name=tag]').val()};
            $form.find(':input[name=tag]').trigger('change');
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                _this.autoCompleteSearchTags();
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.post('/api/user/tag', requestData);
            return query.promise();
          },
          update: function ($form) {
            var tagId = $form.find(':input[name=id]').val();
            var requestData = {'tag': $form.find(':input[name=tag]').val()};
            $form.find(':input[name=tag]').trigger('change');
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                _this.autoCompleteSearchTags();
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.put('/api/image/tag/' + tagId, requestData);
            return query.promise();
          },
          delete: function (tagId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                _this.autoCompleteSearchTags();
                return query.resolve(response);
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/image/tag/' + tagId);
            return query.promise();
          },
          mass: function () {
            return {
              delete: function (requestData) {
                requestData = requestData || {};
                var query = $.Deferred();

                var $form = $('form[name="image-tags-list"]', $(context));
                var appTransport = app.transport();
                var formData = $form.serializeObject();
                requestData.ids = formData.ids;

                appTransport
                  .setRequestData(requestData)
                  .setEvent('onSuccess', function (response) {
                    _this.autoCompleteSearchTags();
                    return query.resolve(response);
                  })
                  .setEvent('onError', function (error) {
                    app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                    return query.reject(error);
                  })
                  .setEvent('onComplete', function () {

                  })
                ;

                appTransport.delete('/api/image/tag/');
                return query.promise();

              },
            }
          }
        }
      };

      _this.context = function () {
        return context;
      };

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();
            delete defaultPageParams['pageSize'];
            delete defaultPageParams['orderBy'];
            delete defaultPageParams['orderByOrder'];
            delete defaultPageParams['group'];
            delete defaultPageParams['queryVal'];
            delete defaultPageParams['query'];
            delete defaultPageParams['q'];

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.buildUrl = function (options) {
        options = _this.pageParams().get();

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.query) ? queryBuilders.push('query=' + options.query + '&' + $.param(options.queryParams)) : '';

        return getUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.getFilters = function () {
        var options = _this.pageParams().get(), filters = {};
        filters = !_.isEmpty(options.query) ? $.extend({}, {'query': options.query}, options.queryParams) : $.extend({}, {'query': 'no-trigger'});
        filters = !_.isEmpty(options.q) ? $.extend(filters, {'search': options.q}) : filters;
        return filters;
      };

      _this.get = function (options) {
        var $imageTagsBody = $('.table__image-tags-body', $(context));
        $(dataTable).addClass('loading-state');
        $('.page__no--records', $imageTagsBody).hide();

        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };

      _this.pager = function () {
        return {
          init: function (response) {
            $(dataTable).mdcPager({
              counts: parseInt(response.total),
              pageSize: _this.pageParams().get()['pageSize'],
              currentPage: _this.pageParams().get()['pageNo'],
              callback: function (objpage) {
                var pageParams = {pageNo: objpage.pageno, pageSize: objpage.pagesize};
                _this.pageParams().set(pageParams);
                _this.get();
              }
            });
          }
        }
      };

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': $(dataTable).attr('data-orderBy'),
          'orderByOrder': $(dataTable).attr('data-orderByOrder')
        }, defaultPageParams);
      };

      _this.autoCompleteSearchTags = function () {
        $.when(_this.imageTagActions().getUserTags()).done(function (response) {
          var $select = $('.page__image_manager--container' + ' .select2-image-by-tags');
          var selectedOptions = [];
          $select.find('option:selected').each(function () {
            selectedOptions.push($(this).val());
          });

          $select.find('option').remove();
          _.each(response.result, function (row) {
            var $option = $('<option > </option>').appendTo($select);
            $option.text(row.tag);
            $option.val(row.id);

            if (_.contains(selectedOptions, row.id)) {
              $option.attr('selected', 'selected');
            }
          });

          /**
           * Select 2 with tags
           */
          $select.select2({
            theme: "bootstrap4",
            placeholder: 'Filter by tags',
            dropdownParent: $select.closest('.modal-header'),
          }).on("select2:unselecting", function (e) {

          }).on("change.select2", function (e) {
            var $btnSelectAll = $('.btn-select-all', $('.page__image_manager--container'));
            if($btnSelectAll.attr('data-action') == 'unselect-all') {
              $btnSelectAll.trigger('click');
            }

            if ($select.val() == '') {
              $btnSelectAll.closest('.col').addClass('d-none');
            } else {
              $btnSelectAll.closest('.col').removeClass('d-none');
            }

            $('form[name="image__list--search"]').trigger('submit');
          });
        });
      };

      return {
        autoCompleteTags: function () {
          _this.autoCompleteSearchTags();
        },

        init: function () {

          _this.destroyModal();
          _this.initModal();

          // Set Page Params to default
          _this.pageParams().set(_this.getDefaultPageParams());

          // Set sorting on sales team
          $('.table__image-tags-list').mdcSort({
            'orderBy': _this.pageParams().get()['orderBy'],
            'orderByOrder': _this.pageParams().get()['orderByOrder'],
            callback: function (obj) {
              var pageParams = {orderBy: obj.orderBy, orderByOrder: obj.orderByOrder};
              _this.pageParams().set(pageParams);
              _this.get();
            }
          });

          // Search box
          $(context + ' :input[name="q"]').val(_this.pageParams().get()['q']);

          $(document).off('submit.' + nameSpace).on('submit.' + nameSpace, context + ' form[name="image-tags-list--search"]', function (e) {
            e.preventDefault();
            var $submitButton = $(this).find(':input[type=submit]');
            $submitButton.button('loading');

            var pageParams = {
              q: $(this).find(':input[name="q"]').val(),
            };
            _this.pageParams().reset();
            _this.pageParams().set(pageParams);

            $.when(_this.get()).done(function (response) {
              _this.pager().init(response);
              $submitButton.button('reset');
            });
          }).off('click.mass_actions__' + nameSpace).on('click.mass_actions__' + nameSpace, context + ' :input[name="mass_actions"]', function (e) {
            if ($(this).is(':checked')) {
              $(':input[name="ids[]"]', $(context)).prop('checked', true);
            } else {
              $(':input[name="ids[]"]', $(context)).prop('checked', false);
            }
          }).off('click.mass_actions__action' + nameSpace).on('click.mass_actions__action' + nameSpace, context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'), message;
            switch (action) {
              case 'mass-delete':
                message = "Are you sure to delete selected image tags?";

                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Mass Action :: Delete')
                  .set('message', message)
                  .set('onok', function (e, value) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    var massDelete = _this.imageTagActions().mass().delete();
                    $.when(massDelete).done(function () {
                      alertify.confirm().close();
                      $('.ajs-button.ajs-ok').button('reset');

                      var data = _this.get();
                      $.when(data).done(function (response) {
                        _this.pager().init(response);
                        $button.button('reset');
                      });

                    }).fail(function (response) {
                      $('.ajs-button.ajs-ok').button('reset');
                      $button.button('reset');
                    });
                  })
                  .set('oncancel', function (e) {
                    $button.button('reset');
                  })
                  .show();
                break;

            }
          })
          ;

          $.when(_this.get()).done(function (response) {
            _this.pager().init(response);
          });


          $(document).off('click.image-tags-list--action__' + nameSpace).on('click.image-tags-list--action__' + nameSpace, context + ' [data-action]', function (e) {
            var action = $(this).attr('data-action'),
              tagId = $(this).attr('data-id'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              message = "Tag Name :: " + $dataRow.find('.col__tag').html() + '<br/>' + 'Image Count :: ' + $dataRow.find('.col__image_count').html() + '<br/>';

            switch (action) {

              case 'edit-tag' :
                _this.$modalEdit.modal('show');
                _this.$modalEdit.find('[data-title]').text('Edit Tag #' + tagId);
                _this.$modalEdit.find('[data-save-text]').text('Update Tag');
                _this.$modalEdit.find('form').attr('method', 'PUT');
                _this.$modalEdit.find(":input[name=id]").val(tagId);
                _this.$modalEdit.find(":input[name=tag]").val($dataRow.find('[data-tag]').text());
                break;
              case 'add-tag' :
                _this.$modalEdit.modal('show');
                _this.$modalEdit.find('[data-title]').text('Add Tag');
                _this.$modalEdit.find('[data-save-text]').text('Save Tag');
                _this.$modalEdit.find('form').attr('method', 'POST');
                _this.$modalEdit.find(":input[name=id]").val('');
                _this.$modalEdit.find(":input[name=tag]").val('');
                break;
              case 'load-images-by-tag' :
                var $pageImageManager = $('.page__image_manager--context');
                $('.grid__upload', $pageImageManager).hide();
                $('.image-tags__list-container', $pageImageManager).hide();
                $('.grid__container', $pageImageManager).show();

                var $select = $('.page__image_manager--container' + ' .select2-image-by-tags');
                $('.btn-list-manage-tags').removeClass('active');
                $('form[name=image__list--search]', $pageImageManager).css({'opacity': 1});
                $('.btn-list-back-to-gallery', $pageImageManager).addClass('d-none');
                app.imagesGetUrl = '/api/image/shared';
                $select.val(tagId);
                $select.trigger('change.select2');

                break;

              case 'trash-tag':
                $button.button('loading');
                alertify.confirm()
                  .set({
                    labels: {
                      ok: "Delete"
                    }
                  })
                  .set({reverseButtons: true, transition: 'zoom', 'modal': true})
                  .setHeader('Confirm Tag Delete')
                  .set('message', message)
                  .set('onok', function (e) {
                    e.cancel = true;
                    $('.ajs-button.ajs-ok').button('loading');
                    if (typeof tagId != 'undefined' && tagId != '') {
                      var tagDelete = _this.imageTagActions().delete(tagId);
                      $.when(tagDelete).done(function () {

                        alertify.confirm().close();
                        $('.ajs-button.ajs-ok').button('reset');

                        $.when(_this.get()).done(function (response) {
                          _this.pager().init(response);
                          $button.button('reset');
                        });

                      }).fail(function () {
                        $('.ajs-button.ajs-ok').button('reset');
                      });
                    }

                  })
                  .set('oncancel', function () {
                    $button.button('reset');
                  })
                  .show();
                break;
            }

          }).off('keydown.image-tag-name__' + nameSpace).on('keydown.image-tag-name__' + nameSpace, '.modal-image-tag-edit :input[name=tag]', function (e) {
            if (e.which === 32)
              return false;
          }).off('change.image-tag-name__' + nameSpace).on('change.image-tag-name__' + nameSpace, '.modal-image-tag-edit :input[name=tag]', function (e) {
            this.value = this.value.replace(/\s/g, "");
          });


        }
      };
    };
  });
})(PreBuilt);

